<template>
  <div class="match-stats-wrapper">
    <!-- Match Overview + Shotmap layout -->
     
    <div class="top-section">
      <!-- Left Column -->
      <div class="left-column">
        <div
          v-for="(group, index) in matchOverviewGroups"
          :key="'overview-' + index"
          class="stats-card"
        >
          <h3 class="group-title">{{ group.groupName }}</h3>

          <div
            v-for="(item, iIndex) in group.statisticsItems"
            :key="'overview-item-' + iIndex"
            class="stat-row"
          >
            <div class="stat-name">{{ item.name }}</div>
            <div class="stat-values">
              <span class="team home">{{ item.home }}</span>
              <div class="bar-wrapper">
                <div
                  class="bar home-bar"
                  :style="{
    width: calcWidth(item.homeValue, item.awayValue, 'home'),
    background: statisticsData.teamColor.home
  }"
                ></div>
                <div
                  class="bar away-bar"
                  :style="{
    width: calcWidth(item.homeValue, item.awayValue, 'away'),
    background: statisticsData.teamColor.away
  }"
                ></div>
              </div>
              <span class="team away">{{ item.away }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column (Shotmap inside same height card) -->
      <div class="right-column">
        <div class="stats-card shotmap-card">
          <h3 class="group-title">Shotmap</h3>
          <div class="shotmap-box">
            <FootballShotmap :shots-data="statisticsData.shotmap"/>
          </div>
        </div>
      </div>
    </div>

    <!-- Other groups below (same as before) -->
    <div class="grid-section">
      <div
        v-for="(group, index) in otherGroups"
        :key="'group-' + index"
        class="stats-card"
      >
        <h3 class="group-title">{{ group.groupName }}</h3>
        <div
          v-for="(item, iIndex) in group.statisticsItems"
          :key="'item-' + iIndex"
          class="stat-row"
        >
          <div class="stat-name">{{ item.name }}</div>
          <div class="stat-values">
            <span class="team home">{{ item.home }}</span>
           <div class="bar-wrapper">
  <div
    class="bar home-bar"
    :style="{
      width: calcWidth(item.homeValue, item.awayValue, 'home'),
      background: statisticsData.teamColor.home
    }"
  ></div>

  <div
    class="bar away-bar"
    :style="{
      width: calcWidth(item.homeValue, item.awayValue, 'away'),
      background: statisticsData.teamColor.away
    }"
  ></div>
</div>

            <span class="team away">{{ item.away }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FootballShotmap from "./FootballShotmap.vue";
export default {
  name: "MatchStatsFull",
  components: {
    FootballShotmap,
  },    
  props: {
    statisticsData: {
      type: Object,
      required: true,
    },
  },
  created() {
     console.log("Statistics Data:", this.statisticsData);
  },
 computed: {
  matchOverviewGroups() {
    return this.statisticsData.statistics.filter(
      (g) => g.groupName === "Match overview"
    );
  },

  otherGroups() {
    return this.statisticsData.statistics.filter(
      (g) => g.groupName !== "Match overview"
    );
  }
},
  methods: {
    calcWidth(home, away, type) {
      const h = parseFloat(home) || 0;
      const a = parseFloat(away) || 0;
      const total = h + a || 1;
      const percent = ((type === "home" ? h : a) / total) * 100;
      return percent + "%";
    },
  },
};
</script>

<style scoped>
.match-stats-wrapper {
  max-width: 1100px;
  margin: 0 auto;
  font-family: "Inter", sans-serif;
  color: #222;
}

/* FIXED */
.top-section {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.left-column {
  flex: 1.5;
}

.right-column {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Cards */
.stats-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

/* Group header */
.group-title {
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 6px;
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 18px;
}

.stat-row {
  margin-bottom: 10px;
}

.stat-name {
  font-size: 14px;
  margin-bottom: 4px;
  text-align: center;
}

.stat-values {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.team {
  width: 15%;
  text-align: center;
  font-weight: 500;
  font-size: 15px;
}

.bar-wrapper {
  width: 70%;
  height: 6px;
  background: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
}

.bar {
  height: 6px;
}
/*
.home-bar {
  background: #38c172;
}
.away-bar {
  background: #007bff;
}*/

/* Shotmap styling fix */
.shotmap-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.shotmap-box {
  flex: 1;
  overflow: hidden;
}

/* Ensure Shotmap fits within parent box */
.shotmap-box >>> .shotmap-container {
  max-width: 100% !important;
  margin: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  padding: 0 !important;
}
.shotmap-box >>> .pitch-container {
  height: 230px !important;
  margin-bottom: 10px !important;
}

/* Grid section */
.grid-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  gap: 20px;
  margin-top: 20px;
}
</style>
